import type { RemoteConfigShape } from "../types/domain";

export const remoteDefaults: RemoteConfigShape = {
  features: {
    ai: true,
    sharedTrips: true,
    notificationCenter: true,
    dataImport: false,
    recovery: true
  },
  plans: {
    free: {
      aiRequestsMonthly: 20,
      storageBytes: 100 * 1024 ** 2,
      maxTrips: null,
      recoveryUiEnabled: false
    },
    premium: {
      aiRequestsMonthly: null,
      storageBytes: 1024 ** 3,
      maxTrips: null,
      recoveryUiEnabled: true
    }
  },
  versions: {
    web: {},
    android: {},
    ios: {}
  }
};
